import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { AppConfig } from "../app.config";
import { Observable } from 'rxjs/Observable';
import { VertragModel } from '../schemas/schemas';
import { ExtendedJwtHttp } from '../_authentication/http/jwthttp';
import { _MatButtonToggleGroupMixinBase } from '@angular/material';
import { IServerSideGetRowsRequest } from 'ag-grid-community';

export class AgGridServerResonse {
    LastRowIndex: number;
    Rows: VertragModel[];
    Success: boolean;
}

@Injectable()
export class AgGridServer {

    constructor(private jwtHttp: ExtendedJwtHttp) {
    }

    public Get(request: IServerSideGetRowsRequest): Observable<AgGridServerResonse> {
        return this.jwtHttp.post(AppConfig.Urls.WebAPI + '/api/agGridServer/GetDatasource', request)
            .map(this.ExtractData)
            .catch(this.HandleError);
    }

    public GetRealEstates() {
        return this.jwtHttp.get(AppConfig.Urls.WebAPI + '/api/agGridServer/GetRealestates')
            .map(this.ExtractData)
            .catch(this.HandleError);
    }

    public GetFlatsByrealEstate(id: string) {
        return this.jwtHttp.get(AppConfig.Urls.WebAPI + '/api/agGridServer/GetByrealEstate' + `?realestateId=${id}`)
            .map(this.ExtractData)
            .catch(this.HandleError);
    }

    private ExtractData(res: Response) {
        let data: AgGridServerResonse = res.json() || [];
        return data;
    }

    private HandleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            errMsg = `${error.status} - ${error.statusText || ''}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/_vertrag/ag-grid-server.service.ts